import React from 'react'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-parallax'

//graphql
import { useQuery } from '@apollo/react-hooks'
import LATEST_BLOGS_QUERY from '../../../queries/blog/latestBlog'
import LoadingRectangle from '../../loaders/LoadingRectangle'
import CardLoading from '../../loaders/CardLoading'

const LatestBlog = () => {

    const { data, loading, error } = useQuery(LATEST_BLOGS_QUERY)

    if(loading){
        return (
            <>
            <LoadingRectangle/>
            <LoadingRectangle/>
            <CardLoading/>
            </>
        )
    }
    if(error) return <p>error</p>

    return (
        <>
        <Parallax style={{ marginTop: '10%', marginBottom: '5%' }} 
        bgImage="https://images.pexels.com/photos/3298637/pexels-photo-3298637.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" strength={500}>
            <div style={{ padding: '5%' }}>{data.blogs.map((blog)=>
                <Link key={blog.id} to={`/blog/${blog.id}`}>
                    <div style={{ border: '4px solid white', padding: '5%', cursor: 'pointer' }}>
                        <h2 style={{ letterSpacing: '0.5rem' }} className="h2-responsive white-text text-center text-uppercase font-weight-bold ml-3">
                            fresh blog from the author 
                        </h2>
                    </div>
                </Link>)}
            </div>
        </Parallax>   
        </>
    )
}

export default LatestBlog
